import { apiCall, apiUpload } from './apiClient';

export const PRODUCT_MEDIA_S3_PATH = 's3://id-creative-media/product-media/';

export const toProductMediaUrl = (urlOrKey) => {
  if (!urlOrKey) return urlOrKey;

  const value = String(urlOrKey);
  if (value.startsWith('s3://id-creative-media/')) {
    return value.replace('s3://id-creative-media/', 'https://id-creative-media.s3.amazonaws.com/');
  }

  if (!value.startsWith('http') && value.startsWith('product-media/')) {
    return `https://id-creative-media.s3.amazonaws.com/${value}`;
  }

  return value;
};

export const getSampleTypesdata = () =>
  apiCall('/designers/master/sample-types');

export const getCategory = () =>
  apiCall('/designers/master/categories');

export const getProductCode = () =>
  apiCall('/designers/master/product-codes');

export const getSubCategory = () =>
  apiCall('/designers/master/subcategories');

export const getProductType = () =>
  apiCall('/designers/master/product-types');

export const postapparel = () =>
  apiCall(`/designers/master/products`, {
    method: 'POST'
  });

export const getMainScreenProducts = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value);
    }
  });

  const queryString = query.toString();
  return apiCall(`/designers/MainScreen/products${queryString ? `?${queryString}` : ''}`);
};
export const uploadProductImages = ({ productId, images, createdBy }) => {
  const formData = new FormData();
  formData.append('product_id', productId);

  if (createdBy !== undefined && createdBy !== null && createdBy !== '') {
    formData.append('created_by', createdBy);
  }

  const files = Array.isArray(images) ? images : [images];
  files.filter(Boolean).forEach((image) => {
    formData.append('images', image);
  });

  console.log("Final FormData before upload:");
  for (let pair of formData.entries()) {
    console.log(`${pair[0]}:`, pair[1]);
  }

  return apiUpload('/designers/upload', formData);
};

export const deleteProductImage = async (imageId) => {
  const id = String(imageId ?? '').trim();

  if (!id) {
    throw new Error('Image id is missing.');
  }

  const encodedImageId = encodeURIComponent(id);
  const endpoint = `/designers/products/images/${encodedImageId}`;

  console.log('[deleteProductImage] calling endpoint:', endpoint, 'imageId:', id);

  return apiCall(endpoint, {
    method: 'DELETE'
  });
};

export const updateProductImage = async (imageId, data) => {
  const id = String(imageId ?? '').trim();

  if (!id) {
    throw new Error('Image id is missing.');
  }

  const encodedImageId = encodeURIComponent(id);
  const endpoint = `/designers/products/images/${encodedImageId}`;

  return apiCall(endpoint, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
};

export const normalizeMainScreenProducts = (response) => {
  const products = response?.data || response?.products || response || [];

  if (!Array.isArray(products)) {
    return [];
  }

  const normalizeImageEntries = (value) => {
    if (Array.isArray(value)) {
      return value;
    }

    if (value && typeof value === 'object') {
      return [value];
    }

    return String(value || '')
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
  };

  const getImageUrl = (entry) => {
    if (entry && typeof entry === 'object') {
      const nested = entry.image_data || entry.imageData || entry.product_image || entry.productImage || entry.product_images?.[0] || entry.images?.[0];
      return (
        entry.image_url ||
        entry.imageUrl ||
        entry.image ||
        entry.url ||
        entry.location ||
        entry.key ||
        entry.path ||
        entry.s3_key ||
        entry.s3Key ||
        entry.s3Url ||
        entry.s3_url ||
        entry.media_url ||
        entry.file_url ||
        (nested && (nested.image_url || nested.imageUrl || nested.url || nested.location || nested.key || nested.path || nested.s3Url || nested.s3_url || nested.media_url || nested.file_url)) ||
        ''
      );
    }

    return String(entry || '').trim();
  };

  const getImageId = (entry) => {
    if (entry && typeof entry === 'object') {
      const nested = entry.image_data || entry.imageData || entry.product_image || entry.productImage || entry.product_images?.[0] || entry.images?.[0];
      return (
        entry.image_id ||
        entry.imageId ||
        entry.id ||
        entry.product_media_id ||
        entry.productMediaId ||
        entry.product_image_id ||
        entry.productImageId ||
        entry.image_ids?.[0] ||
        entry.imageIds?.[0] ||
        (nested && (nested.image_id || nested.imageId || nested.id || nested.product_media_id || nested.productMediaId || nested.product_image_id || nested.productImageId || nested.image_ids?.[0] || nested.imageIds?.[0])) ||
        ''
      );
    }

    return '';
  };

  return products.filter(Boolean).map((product) => {
    const recordType = String(product.record_type || product.recordType || '').trim().toLowerCase() || (
      product.fabric_id || product.fabric_images || product.fabricImages || product.fabricsup || product.materialcd
        ? 'fabric'
        : 'product'
    );

    const imageEntries = normalizeImageEntries(
      product.imageItems ||
      product.image_items ||
      product.fabric_images ||
      product.fabricImages ||
      product.product_images ||
      product.productImages ||
      product.product_image ||
      product.productImage ||
      product.image_data ||
      product.imageData ||
      product.images ||
      product.imageUrls ||
      product.image_urls ||
      product.image_url ||
      product.image ||
      product.url ||
      product.location ||
      product.key
    );

    const imageIdSource =
      product.imageIds ||
      product.image_ids ||
      product.image_id ||
      product.product_image_ids ||
      product.product_image_id ||
      product.productMediaIds ||
      product.product_media_ids ||
      product.productMediaId ||
      product.product_media_id ||
      [];
    const imageIds = (Array.isArray(imageIdSource) ? imageIdSource : String(imageIdSource || '').split(','))
      .map((imageId) => String(imageId || '').trim())
      .filter(Boolean);

    const imageItems = imageEntries
      .map((entry, index) => {
        const url = getImageUrl(entry);
        const id = getImageId(entry) || imageIds[index] || '';
        const displayOrder =
          (entry && typeof entry === 'object' &&
            (entry.displayOrder ?? entry.display_order ?? entry.displayorder)) ??
          index + 1;
        return {
          id: id || undefined,
          url: url ? toProductMediaUrl(url) : '',
          displayOrder: Number(displayOrder) || index + 1,
        };
      })
      .filter((item) => item.url);

    imageItems.sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));

    const imageUrls = imageItems.map((item) => item.url);

    return {
      ...product,
      id: product.id || product.product_id,
      uniqueId: product.uniqueId || product.record_group_id || product.product_code || product.product_id,
      uniqueRecordId: product.uniqueRecordId || product.record_group_id,
      recordType,
      fabric_id: product.fabric_id || product.fabricId,
      fabricsup: product.fabricsup || product.fabricsup,
      materialcd: product.materialcd || product.materialCd,
      fabrictype: product.fabrictype || product.fabricType || product.fabric_type,
      subCategory: product.subCategory || product.sub_category,
      product_code: product.product_code || product.productCode,
      producttype: product.producttype || product.product_type,
      isDenim: product.isDenim ?? product.is_denim,
      imageUrls,
      imageIds: imageItems.map((item) => item.id).filter(Boolean),
      imageItems,
    };
  });
};


export const deleteapparel = (id) =>
  apiCall(`/designers/master/products/${id}`, {
    method: 'DELETE'
  });


export const putEditApparel = (id, data) =>
  apiCall(`/designers/master/products/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  });

export const getAppareluse = (id) =>
  apiCall(`/designers/products/${id}`, {
    method: 'GET'
  });


  export const searchDesigners = (keyword) =>
  apiCall(`/designers/search?keyword=${encodeURIComponent(keyword)}`, {
    method: 'GET',
  });
